import React from 'react';
import { TCoreOptions } from '../types/options';
import { getFontStyles } from '../utils/styles';
import styles from './list.module.css';

type CoreListItemTextProps = {
    primary?: string;
    secondary?: string;
    palette: TCoreOptions;
};

export const CoreListItemText = ({ primary, secondary, palette }: CoreListItemTextProps) => {
    const fontStyle = getFontStyles(palette);
    const primaryColor = palette.onSurfaceVariant;
    const secondaryColor = palette.onSurfaceVariant;

    return (
        <div className={styles.text}>
            {primary !== undefined && (
                <span className={styles.textPrimary} style={{ ...fontStyle, color: primaryColor }}>
                    {primary}
                </span>
            )}
            {secondary !== undefined && (
                <span className={styles.textSecondary} style={{ ...fontStyle, color: secondaryColor }}>
                    {secondary}
                </span>
            )}
        </div>
    );
};
